import dayjs from 'dayjs';
import {
  getFormatDateByContinent,
  MONTH_DAY_YEAR_FORMAT,
} from 'src/utils/timeUtils';
import { GraphTimeData } from 'src/routes/IndividualDashboard/modules/dashboard/types';
import { COMMON_COLORS } from '@neteera/neteera-web-nextgen';
import { defineMessages, IntlShape } from 'react-intl';

export const getDaysBetweenDates = (startTime: string, endTime: string) => {
  const days = [];
  const diffDays = dayjs(endTime)?.diff(dayjs(startTime), 'days');
  for (let i = 0; i <= diffDays; i++) {
    // Runs 5 times, with values of step 0 through 4.
    days.push(
      dayjs(startTime)
        .add(i, 'day')
        .format(getFormatDateByContinent(MONTH_DAY_YEAR_FORMAT)),
    );
  }
  return days;
};

export const calculateBedActivityTrendLineData = (data: GraphTimeData[]) => {
  const dataPerDay = {} as Record<string, number>;
  data.map(item => {
    dataPerDay[
      dayjs(item?.date).format(getFormatDateByContinent(MONTH_DAY_YEAR_FORMAT))
    ] = item?.value;
  });
  return dataPerDay;
};

export const getWidgetConfig = (
  intl: IntlShape,
  hasSleepWakeFeature: boolean,
) => {
  let config = [
    {
      key: 'highMotion',
      label: intl.formatMessage(messages.bedActivityHighMotionLabel),
      color: COMMON_COLORS.yellowDark,
      stackId: 'motion',
    },
    {
      key: 'mediumMotion',
      label: intl.formatMessage(messages.bedActivityMediumMotionLabel),
      color: COMMON_COLORS.yellowMid,
      stackId: 'motion',
    },
    {
      key: 'lowMotion',
      label: intl.formatMessage(messages.bedActivityLowMotionLabel),
      color: COMMON_COLORS.yellowLight,
      stackId: 'motion',
    },
  ];

  if (hasSleepWakeFeature) {
    config = [
      ...config,
      {
        key: 'remSleep',
        label: intl.formatMessage(messages.bedActivityRemSleepLabel),
        color: COMMON_COLORS.greenDark,
        stackId: 'sleep',
      },
      {
        key: 'sleep',
        label: intl.formatMessage(messages.bedActivitySleepLabel),
        color: COMMON_COLORS.greenLight,
        stackId: 'sleep',
      },
    ];
  }
  return config;
};

export const messages = defineMessages({
  bedActivity: {
    id: 'IDB.BedActivity.graph',
    defaultMessage: 'Activity',
  },
  bedActivitySubtitle: {
    id: 'IDB.BedActivity.bedActivitySubtitle',
    defaultMessage: '(h/Day)',
  },
  bedActivityRightDesc: {
    id: 'IDB.BedActivity.bedActivityRightDesc',
    defaultMessage: '*Occupancy is analyzed from {startTime} over 24h',
  },
  bedActivitySleepInfo: {
    id: 'IDB.BedActivity.bedActivitySleepInfo',
    defaultMessage: '*Sleep period is analyzed from {startTime} to {endTime}',
  },
  bedActivityLegend: {
    id: 'IDB.BedActivity.bedActivityLegend',
    defaultMessage: 'Occupancy (hours per day)   ---   Occupancy trend',
  },
  bedActivityHighMotionLabel: {
    id: 'IDB.BedActivity.bedActivityHighMotionLabel',
    defaultMessage: 'High motion',
  },
  bedActivityMediumMotionLabel: {
    id: 'IDB.BedActivity.bedActivityMediumMotionLabel',
    defaultMessage: 'Medium motion',
  },
  bedActivityLowMotionLabel: {
    id: 'IDB.BedActivity.bedActivityLowMotionLabel',
    defaultMessage: 'Low motion',
  },
  bedActivitySleepLabel: {
    id: 'IDB.BedActivity.bedActivitySleepLabel',
    defaultMessage: 'Sleep',
  },
  bedActivityRemSleepLabel: {
    id: 'IDB.BedActivity.bedActivityRemSleepLabel',
    defaultMessage: 'REM Sleep',
  },
  hour: {
    id: 'DeviceMeasurements.index.hour',
    defaultMessage: 'h',
  },
});
